import React, { useState, useEffect } from "react";
import styles from "./Home.module.scss";
import { useDataStore } from "store/DataStoreContext";
import { Skeleton } from "antd";
import TitleAndBreadCrumb from "components/TitleAndBreadCrumb/TitleAndBreadCrumb";
import { TranslateLanguage } from "util/Translate";
import { BundleMockData } from "./MockHomeData";
import { actionType } from "store/dataReducer";
import BundleCard from "./Components/BundleCard/BundleCard";
import _ from "lodash";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import { LeftArrow, RightArrow } from "./Components/BundleCard/arrow";
import { getBundleList } from "api/bundle";
import SkeletonBundle from "./SkeletonBundle";
import useAuth from "../../context/auth";

const translate = new TranslateLanguage();

const HomeBundle = ({ onCLickLoadMore }) => {
  const {
    state: { bundle, educationType },
    dispatch,
  } = useDataStore();
  const {
    state: { user },
  } = useAuth();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchBundle();
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [educationType.activeLevel]);

  const fetchBundle = async () => {
    if (educationType.activeLevel) {
      setIsLoading(true);
      const bundleData = await getBundleList({
        level: educationType.activeLevel,
      });

      dispatch({
        type: actionType.FETCH_BUNDLE,
        payload: { bundle: bundleData },
      });
      setIsLoading(false);
    }
  };

  const handleClickCard = (id) => {
    history.push(`/bundle/detail`, { bundleId: id });
  };

  return (
    <div className={styles.home_bundle}>
      {!isLoading ? (
        !_.isEmpty(bundle.data) && (
          <div className={styles.home_bundle_container}>
            <div className={styles.divSuggestTitle}>
              <TitleAndBreadCrumb
                title={{ text: translate.convert("ชุดข้อสอบ") }}
                option={{
                  options: {
                    more: {
                      text: translate.convert("ดูทั้งหมด"),
                      onClick: () => onCLickLoadMore(),
                    },
                  },
                }}
              />
            </div>
            <div className={styles.divCardBundle}>
              <BundleCard
                handleClickCard={handleClickCard}
                refetch={fetchBundle}
              />
            </div>
          </div>
        )
      ) : (
        <SkeletonBundle />
      )}
    </div>
  );
};

export default HomeBundle;
